import PropTypes from "prop-types";
import React from "react";
import injectSheet from "react-jss";

const styles = () => ({
  text: {
    color: "white",
    fontWeight: "400",
    fontSize: "3.5rem",
    textAlign: "center",
    width: "90%",
    maxWidth: "100vw",
    paddingBottom: "4rem",
    position: "absolute",
    left: "5%",
    "@media (max-height: 950px) and (min-height: 740px)": {
      fontSize: "2.5rem",
    },
    "@media (max-width: 1800px)": {
      fontSize: "2.5rem",
    },
    "@media (max-width: 823px)": {
      fontSize: "1.5rem",
      fontWeight: "600",
      "@media (orientation: landscape)": {
        marginTop: "none"
      }
    }
  }
});

const HeroText = ({ classes, className, children }) => (
  <div className={`${className} ${classes.text}`}>{children}</div>
);

HeroText.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string
};

export default injectSheet(styles)(HeroText);



// WEBPACK FOOTER //
// ./src/components/Hero/HeroText.jsx